import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";

const ReportBuilderOrderOptionAbove = () => {
  return <option value='[{"Key":"Type","Value":"Orders"},{"Key":"Location","Value":"Above"}]'>Orders - Above</option>;
};

const ReportBuilderOrderOptionBelow = () => {
  return <option value='[{"Key":"Type","Value":"Orders"},{"Key":"Location","Value":"Below"}]'>Orders - Below</option>;
}

registerExtension('reportbuilder.location.select', ReportBuilderOrderOptionAbove, "ReportBuilderOrderOptionAbove");
registerExtension('reportbuilder.location.select', ReportBuilderOrderOptionBelow, "ReportBuilderOrderOptionBelow");
